import React from 'react'
import ErrorLoading from './ErrorLoading'
import Dashboard from './Dashboard'
import Loading from './Loading'
import { useRefetch } from '../../../hooks/useRefetch'
import { useMembershipJourney } from '../../../hooks/useMembershipJourney'

export const MembershipJourneyDashboardWrapper = ({ authReady, onEditProfile, history }) => {
  const { isFetching, reload } = useRefetch()
  const { person, loading, error, refetch } = useMembershipJourney()

  if (!authReady || loading || isFetching) {
    return <Loading />
  }
  
  const pgmProgress = person?.pgmProgress
  
  if (error || !pgmProgress || !person) {
    return <ErrorLoading refetch={refetch} reload={reload} />
  }

  return (
    <Dashboard
      me={person}
      pgmProgress={pgmProgress}
      onEditProfile={onEditProfile}
      history={history}
      authReady={authReady}
    />
  )
}

export default MembershipJourneyDashboardWrapper
